import { GoalIcon } from "@components/Goals/GoalIcon";
import { Caption } from "@components/Typography";
import { GoalType } from "@ctypes";
import { useGoalFlow } from "@hooks";
import { useStyles } from "./styles";

export const GoalTypeButton = () => {
  const styles = useStyles();

  const {
    goalProps: { goalType = GoalType.GenerationalWealth, goalName },
  } = useGoalFlow();

  return (
    <div style={styles.container}>
      <GoalIcon type={goalType} />
      {goalName && <Caption style={styles.text}>{goalName}</Caption>}
    </div>
  );
};
